var _rect, _g, _g2, _path, _path2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 106,
    viewBox: "0 0 414 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_6907)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 106,
    fill: "#EFE9F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2006_6907)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 106,
    fill: "#EFE9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.115 52.4385C204.609 37.3291 184.921 26.7168 165.002 29.2061C159.736 29.8643 154.467 31.4638 150.222 34.6158C144.65 38.7534 141.375 45.0924 137.948 51.0421C130.693 63.6365 121.984 75.3934 111.993 86.0797C107.062 91.3529 101.64 96.4804 94.8947 99.2141C81.3709 104.695 65.1644 98.9097 55.6746 88.2511C49.7465 81.593 45.6291 73.0581 40.3884 65.8991C36.6696 66.8306 32.2414 67.9501 27.4823 69.1743C14.3276 72.5584 3.65589 75.4538 3.65589 75.4538C3.65589 75.4538 12.2575 55.8388 24.8909 59.1118C28.9281 60.1577 33.0807 60.9522 36.8635 61.5497C34.0086 58.4144 30.7384 55.7705 26.7105 53.9978C18.7681 50.5026 9.41305 51.3216 1.01225 53.8523C-7.80923 56.5097 -16.2288 61.1046 -22.2 68.0048C-32.8373 80.2969 -34.1582 97.5395 -34.984 113.504L-22.5916 116.093C-18.8619 110.922 -12.9331 105.241 -5.67146 107.122C6.96189 110.395 20.7308 111.21 20.7308 111.21C20.7308 111.21 10.0746 113.801 -3.08003 117.185C-5.28938 117.753 -7.42604 118.307 -9.45653 118.837L128.13 147.578C168.68 137.928 198.614 128.112 237.409 119.987C239.433 119.563 241.362 108.227 240.699 105.539C236.029 86.5939 229.621 67.5479 217.115 52.4385ZM179.176 67.4924C166.021 70.8764 155.35 73.7719 155.35 73.7719C155.35 73.7719 163.951 54.1568 176.585 57.4298C189.218 60.7027 202.987 61.5173 202.987 61.5173C202.987 61.5173 192.331 64.1084 179.176 67.4924L179.176 67.4924Z",
    fill: "#E7DEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.961 43.7702C443.846 30.1513 423.096 21.803 403.58 26.5003C398.42 27.7423 393.363 29.9199 389.496 33.5261C384.421 38.2598 381.873 44.9249 379.132 51.2199C373.328 64.5455 365.986 77.201 357.251 88.9358C352.939 94.7265 348.123 100.427 341.725 103.897C328.898 110.853 312.147 106.913 301.527 97.3805C294.892 91.4257 289.848 83.4038 283.841 76.8745C280.249 78.2154 275.974 79.8222 271.381 81.57C258.686 86.4013 248.404 90.47 248.404 90.47C248.404 90.47 254.763 70.0174 267.682 71.8596C271.811 72.4483 276.027 72.7744 279.852 72.9458C276.665 70.1488 273.12 67.8864 268.92 66.5745C260.637 63.9877 251.432 65.846 243.366 69.2986C234.896 72.9241 227.042 78.4302 221.879 85.9538C212.68 99.3565 213.292 116.639 214.253 132.596L226.857 133.785C229.987 128.23 235.244 121.923 242.67 122.982C255.59 124.824 269.364 124.096 269.364 124.096C269.364 124.096 259.064 127.861 246.369 132.692C244.237 133.504 242.175 134.293 240.217 135.045L380.151 148.248C419.371 134.132 448.022 121.036 485.668 108.631C487.632 107.984 488.283 96.503 487.325 93.9058C480.569 75.6009 472.075 57.3891 457.961 43.7702ZM421.939 62.9651C409.244 67.7964 398.962 71.8651 398.962 71.8651C398.962 71.8651 405.321 51.4125 418.24 53.2547C431.16 55.0969 444.934 54.3694 444.934 54.3694C444.934 54.3694 434.634 58.1338 421.939 62.9651L421.939 62.9651Z",
    fill: "#E7DEEB"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2006_6907)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.613 70.1441C318.568 61.3783 312.203 56.8412 298.883 61.55C295.361 62.795 291.989 64.7022 289.572 67.5488C286.399 71.2855 282.919 74.4823 281.515 79.1745C269.272 80.5816 275.849 67.5489 271.516 70.554C268.967 74.994 266.057 79.4045 261.85 82.3283C253.416 88.1907 283.417 86.5302 275.165 80.4458C270.011 76.645 265.801 71.2557 261.04 67.0007C258.628 68.208 255.758 69.6528 252.676 71.2204C244.159 75.5536 237.273 79.1745 237.273 79.1745C237.273 79.1745 240.044 64.1056 249.272 64.5304C252.222 64.6661 255.21 64.608 257.912 64.4662C255.441 62.6858 252.763 61.3126 249.703 60.6645C243.67 59.3867 237.357 61.3521 231.978 64.3792C226.468 68.8371 224.506 72.0391 221.502 77.7775C216.152 88 218.016 100.319 220.015 111.667L228.968 111.646C230.705 107.456 230.638 102.582 235.942 102.826C245.171 103.251 254.787 101.778 254.787 101.778C254.787 101.778 247.863 105.183 239.346 109.516C237.916 110.244 236.533 110.95 235.219 111.624C235.219 111.624 303.128 111.396 334.619 111.396C366.111 111.396 321.992 111.396 355.992 111.396C357.317 110.798 355.29 105.767 354.401 103.976C348.136 91.3494 340.659 78.9099 329.613 70.1441ZM327.757 91.2208C319.24 95.554 312.355 99.1749 312.355 99.1749C312.355 99.1749 315.125 84.106 324.354 84.5308C333.583 84.9555 334.294 83.4831 334.294 83.4831C334.294 83.4831 336.275 86.8876 327.757 91.2208Z",
    fill: "#26ACB5"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2006_6907)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.606 51.7786C243.808 46.0844 248.23 41 253.98 41H319.765C325.515 41 329.936 46.0844 329.139 51.7786L321.015 109.753C320.36 114.427 316.362 117.905 311.642 117.905H262.103C257.383 117.905 253.384 114.427 252.729 109.753L244.606 51.7786Z",
    fill: "#9F7CAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.871 41H319.74C325.498 41 329.922 46.0982 329.111 51.7987L320.861 109.773C320.197 114.438 316.202 117.905 311.49 117.905H286.871V41Z",
    fill: "#5F2478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.208 52.4626C263.208 50.6079 264.637 49.0643 266.487 48.9323C281.877 47.8348 291.883 47.8098 307.262 48.9274C309.109 49.0617 310.534 50.6042 310.534 52.4562V61.9992C310.534 64.072 308.761 65.7018 306.694 65.5487C292.062 64.465 282.278 64.3835 267.06 65.538C264.988 65.6951 263.208 64.0639 263.208 61.9864V52.4626Z",
    fill: "#EFE9F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_6907",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 48,
    width: 48,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.209 52.4621C263.209 50.6075 264.638 49.0638 266.488 48.9319C281.878 47.8344 291.884 47.8093 307.263 48.927C309.11 49.0612 310.535 50.6037 310.535 52.4558V61.9987C310.535 64.0715 308.762 65.7013 306.695 65.5482C292.063 64.4645 282.279 64.383 267.061 65.5375C264.989 65.6946 263.209 64.0634 263.209 61.986V52.4621Z",
    fill: "#EFE9F1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_6907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.465 58.7474L290.026 67.621H284.903L287.465 58.7474Z",
    fill: "#5F2478"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.759,
    y: 46.9176,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.124,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.899,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.674,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.449,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.814,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.589,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.364,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.14,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.507,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.282,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.057,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.83,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.197,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.972,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.747,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.521,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.886,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.662,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.438,
    y: 46.9177,
    width: 0.591575,
    height: 4.7326,
    fill: "#47165B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.211,
    y: 46.9177,
    width: 1.18315,
    height: 8.28205,
    fill: "#47165B"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.109 110.856C235.109 110.856 235.298 100.996 248.172 99.0245L235.109 110.856Z",
    fill: "#26ACB5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M340.541 111.931C340.541 111.931 337.764 102.469 324.825 103.955L340.541 111.931Z",
    fill: "#26ACB5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.558 110.342C235.558 110.342 231.868 101.196 242.939 94.3369L235.558 110.342Z",
    fill: "#26ACB5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M339.973 111.552C339.973 111.552 341.126 101.757 328.64 98.0538L339.973 111.552Z",
    fill: "#26ACB5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.504 114.503C237.504 114.503 235.825 104.778 222.825 104.861L237.504 114.503Z",
    fill: "#26ACB5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M339.191 116.079C339.191 116.079 338.251 106.254 350.815 102.913L339.191 116.079Z",
    fill: "#26ACB5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M235.284 113.522C235.284 113.522 239.002 104.38 227.925 97.5754L235.284 113.522Z",
    fill: "#26ACB5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M341.075 114.549C341.075 114.549 335.082 106.708 343.977 97.2275L341.075 114.549Z",
    fill: "#26ACB5"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3752 93.5612L100.329 68.9325L73.6412 58.0958L69.6875 95.5315L96.3752 93.5612Z",
    fill: "#77474E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 129.96C120.908 131.073 118.573 132.078 116.203 132.97C111.464 134.757 106.571 136.106 101.552 137.006C96.6464 137.889 91.6098 138.337 86.5732 138.337C79.7691 138.337 73.0042 137.524 66.4619 135.914C63.9 135.288 61.3162 134.523 58.7762 133.631C58.5099 133.535 58.2394 133.439 57.9731 133.343C54.822 132.204 51.7232 130.869 48.7424 129.359C48.3408 129.159 47.9393 128.954 47.5378 128.737C47.0926 128.511 46.6518 128.272 46.2066 128.024C45.6392 127.715 45.0762 127.393 44.5132 127.067C42.6278 125.979 40.7729 124.805 39.0009 123.582L38.8831 123.504C38.7784 123.43 38.6736 123.361 38.5732 123.287C38.6387 122.943 38.6998 122.63 38.7565 122.351C38.9747 121.26 39.1188 120.659 39.1188 120.659L51.0686 96.056L54.3987 89.2006L56.0222 88.5349L68.2863 83.5109H98.2612L107.719 87.4084C107.719 87.4084 107.767 87.5868 107.863 87.9305C108.806 91.3017 114.305 110.441 122.837 129.168C122.955 129.429 123.077 129.694 123.2 129.96Z",
    fill: "#51BDC4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1702 74.7021C105.364 69.7745 112.863 54.3115 107.919 40.1646C102.975 26.0177 87.46 18.5441 73.266 23.4718C59.072 28.3994 51.5734 43.8624 56.5175 58.0093C61.4616 72.1562 76.9762 79.6298 91.1702 74.7021Z",
    fill: "#824E55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0679 88.3009L56.0211 88.5343L47.7239 127.853L47.652 128.196L47.5365 128.737C47.0899 128.51 46.6496 128.271 46.2062 128.025C45.6378 127.713 45.0757 127.393 44.5105 127.066C42.6275 125.98 40.7725 124.803 38.9988 123.583L38.8801 123.502C38.7771 123.431 38.6709 123.359 38.571 123.288C37.2157 122.345 35.8947 121.361 34.605 120.346C34.5956 120.34 34.5894 120.334 34.58 120.325C32.2785 118.476 30.0614 116.487 27.941 114.374C26.5732 113.01 25.2585 111.607 24 110.166L24.1905 109.369L24.2092 109.288L24.4466 108.273C26.5576 99.3873 33.6994 92.568 42.6962 90.85L54.6502 88.5686L56.0679 88.3009Z",
    fill: "#51BDC4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.728 117.048C134.206 120.037 130.43 122.743 126.446 125.118C126.057 125.353 125.66 125.583 125.263 125.814C123.569 126.788 121.845 127.697 120.1 128.545C117.808 129.659 115.473 130.664 113.104 131.556L112.92 130.694L103.55 86.2857L104.763 86.5164L116.922 88.8392C125.918 90.5575 133.062 97.378 135.17 106.265L137.496 116.083L137.728 117.048Z",
    fill: "#51BDC4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.206 45.6616C114.406 48.3746 114.921 60.628 107.135 65.9473C105.606 66.9941 101.76 68.9234 102.482 67.5628C102.646 67.2525 102.803 66.9491 102.962 66.6497C109.24 54.6592 111.179 47.9888 105.291 36.7207C101.544 29.5456 86.5665 27.0483 79.2514 28.8232C76.167 29.5719 72.7103 31.9001 71.1022 35.3652C68.4448 41.078 73.7116 53.9532 74.1036 62.4538C74.206 64.7304 73.9633 66.694 73.1267 68.1221C72.6059 69.0123 71.8506 68.3717 71.0393 67.1747C69.3143 64.632 67.3276 59.5688 66.775 61.3864C65.1814 66.652 70.0461 71.2091 71.679 73.0515C72.014 73.4282 72.3472 73.7866 72.6734 74.125L72.6748 74.129C72.8623 74.3217 73.0541 74.5133 73.2374 74.6939L73.2388 74.6979C78.2718 79.6572 82.556 80.5697 86.9741 83.2139C88.7078 84.2471 90.4589 85.5415 92.286 87.4502C93.5376 88.7569 94.5942 90.1404 95.4799 91.5508C99.9492 98.613 100.27 106.328 100.36 108.425C100.542 112.793 100.854 120.298 96.1474 126.23C90.2381 133.68 81.8268 131.842 80.1109 137.565C80.0883 137.632 80.0698 137.698 80.0514 137.765C79.9924 137.993 79.9457 138.216 79.9154 138.434C76.5637 138.391 73.1965 138.145 69.8835 137.697C69.4382 137.64 68.9914 137.578 68.5405 137.505C68.0455 137.437 67.5503 137.356 67.048 137.267C66.9195 136.953 66.7911 136.638 66.6653 136.318C64.4798 130.844 62.7117 124.609 61.9717 118.034C61.5024 113.835 61.0363 109.672 61.0889 105.485C61.124 102.755 61.3768 100.014 62.002 97.2404C62.4993 95.0133 63.2295 92.7653 64.2726 90.4869C66.5642 85.4858 69.2197 82.8091 68.3427 78.6729C67.0926 72.7688 60.5921 73.1187 55.4736 65.3098C51.976 59.9696 47.5106 52.0724 47.002 45.883C46.5203 40.0346 46.1054 34.9597 48.5551 28.9961C49.1458 27.5657 54.4734 17.1945 63.2857 12.7349C67.3478 10.6845 73.0488 14.8042 78.6098 14.1862C85.002 13.4735 88.6625 13.0641 92.8591 14.4398C99.9505 16.7592 103.757 22.5868 107.29 28.0023C110.056 32.2383 113.634 37.7165 114.206 45.6616Z",
    fill: "#2F2E41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.699 84.7806C111.699 84.7806 88.7364 64.1592 99.799 62.556C110.862 60.9528 117.143 74.0752 117.143 74.0752L119.624 82.8837L112.855 85.5485L111.699 84.7806Z",
    fill: "#A0616A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.264 168.665C125.057 167.938 126.618 172.123 124.599 170.785C116.504 166.424 120.573 167.865 120.042 164.933L115.226 164.868L113.747 156.504L111.54 150.523L116.854 140.603C117.213 139.929 117.718 139.343 118.332 138.886C118.945 138.43 119.653 138.114 120.404 137.961L114.188 133.992L128.268 120.067L109.786 84.9799L110.982 83.595L118.964 74.3367L120.195 72.9084L152.359 119.397L146.68 134.351L140.532 150.918L140.486 154.354L139.069 167.802L140.208 175.08L138.877 181.844L132.596 170.895C126.997 174.834 133.639 163.234 126.867 164.304L128.264 168.665Z",
    fill: "#7DCDD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_6907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 106,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2006_6907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 414,
    height: 106,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2006_6907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.429,
    height: 68,
    fill: "white",
    transform: "translate(218 41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2006_6907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.4286,
    height: 72.8571,
    fill: "white",
    transform: "translate(243.096 41)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.11501d78067d108aa2f3e7e1b88c8ff1.svg";
export { ForwardRef as ReactComponent };